// Generated from @cascade/api-contracts. Do not edit.
// Run: pnpm --filter @cascade/api-client build

import type {
  TApiRequestOptions,
  TApiTransport,
} from '#request/request.types.ts';
import type {
  TCreateApiKeyRequestPayload,
  TCreateApiKeyResponsePayload,
  TDeleteApiKeyRequestPayload,
  TDeleteApiKeyResponsePayload,
  TListApiKeysRequestPayload,
  TListApiKeysResponsePayload,
  TUpdateApiKeyRequestPayload,
  TUpdateApiKeyResponsePayload,
} from './api-keys.types.ts';

export const createApiKeysApi = (transport: TApiTransport) => ({
  /** Creates an API key for a project */
  createApiKey: (
    payload: TCreateApiKeyRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TCreateApiKeyRequestPayload, TCreateApiKeyResponsePayload>(
      '/create_api_key',
      payload,
      options,
    ),

  /** Deletes an API key for a project */
  deleteApiKey: (
    payload: TDeleteApiKeyRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TDeleteApiKeyRequestPayload, TDeleteApiKeyResponsePayload>(
      '/delete_api_key',
      payload,
      options,
    ),

  /** Lists API keys for a project */
  listApiKeys: (
    payload: TListApiKeysRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TListApiKeysRequestPayload, TListApiKeysResponsePayload>(
      '/list_api_keys',
      payload,
      options,
    ),

  /** Renames an API key. The expiration date is fixed at creation. */
  updateApiKey: (
    payload: TUpdateApiKeyRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TUpdateApiKeyRequestPayload, TUpdateApiKeyResponsePayload>(
      '/update_api_key',
      payload,
      options,
    ),
});
